import styled from 'styled-components'
import {
	PRIMARY_COLOR,
	BLUE,
	DARKBLUE_PLANALTO,
	BACKGROUNDBLACKFRIDAYHEADER,
} from '../../../styles/colors.style'
import { breakpoints } from '../../../constants/breakpoits.constants'
import { isBlackFriday } from '../../../helpers/isBlackFriday'

export const Section = styled.section`
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
	min-height: 77px;
	background: ${isBlackFriday
		? 'linear-gradient(to bottom, #000000, #FFD017)'
		: DARKBLUE_PLANALTO};
	border-radius: 5px;
`
export const Container = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-evenly;
	align-items: center;

	@media (max-width: ${breakpoints.MOBILE_IFRAME_PLANALTO}px) {
		flex-direction: column;
		flex-wrap: nowrap;
		align-items: normal;
		min-height: 317px;
		padding: 0 15px 0 15px;
	}
`

export const StyledContainerReverseRounded = styled.div`
	padding: 5px 7px;
	position: absolute;
	z-index: 2;
	top: 6%;
	right: 35px;
	width: 45px;
	height: 45px;
	border: 1px solid #666;
	border-radius: 100%;
	background: #fff;

	@media (min-width: ${breakpoints.MOBILE_IFRAME_PLANALTO}px) {
		background: none;
		border-radius: 0;
		border: 0;
		cursor: pointer;
		position: unset;
		transform: translate(0, 0);
	}

	.ico-reverse {
		transform: rotate(270deg);
		color: #517abc;
		font-size: 22px;
		height: 100%;
		width: 27px;
		display: flex;
		justify-content: center;
		align-items: center;

		@media (min-width: ${breakpoints.MOBILE_IFRAME_PLANALTO}px) {
			transform: rotate(0);
			color: #fff;
		}
	}
`
